import { Alert, Container, Pagination, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getLogs } from '../api/api-middleware';
import LogsTable from '../components/logs-management/LogsTable';
import useAuthToken from '../hooks/getUserData';
import DashboardLayout from '../layout/dashboard/DashboardLayout';
import { logsFields } from '../staticData/tableHead';

const Logs = () => {
  const token = useAuthToken();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const pageSize = 15;
  const [totalPages, setTotalPages] = useState(0);

  const fetchData = async (pageNumber) => {
    try {
      if (token) {
        setLoading(true);
        const pageToFetch = pageNumber !== undefined ? pageNumber : page;
        const response = await getLogs(token, pageSize, pageToFetch, searchTerm);

        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        setItems(data?.logs || []);
        setTotalPages(Math.ceil(data?.total / pageSize));
        setError(null);
      }
    } catch (error) {
      setError(error.message || 'An error occurred while fetching logs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchData(0);
      setPage(0);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage - 1);
    fetchData(newPage - 1);
  };

  const handleFilterByName = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <DashboardLayout>
      <Container maxWidth="xl">
        <Stack spacing={2}>
          {error ? (
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          ) : (
            <>
              <LogsTable
                filteredData={items}
                columnFields={logsFields}
                tableName={'Logs'}
                loading={loading}
                fetchData={fetchData}
                page={page}
                pageSize={pageSize}
                handleFilterByName={handleFilterByName}
                searchTerm={searchTerm}
              />
              {totalPages > 1 && (
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={handlePageChange}
                  sx={{ alignSelf: 'center' }}
                />
              )}
            </>
          )}
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default Logs;
